import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Spices from "./pages/Spices/Spices";
import Cart from "./pages/Cart/Cart";
import Incenses from "./pages/Incenses/Incenses";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Terms from "./pages/Terms";
import Checkout from "./pages/Checkout/Checkout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import B2B from "./pages/B2B/B2B";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import { ROUTE_PATH } from "./helper/Constants";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { loadCart } from "./redux/slices/cartSlice";
import { loadAddress } from "./redux/slices/addressSlice";
import { sagaActions } from "./redux/sagas/sagaActions";
import MyOrders from "./pages/MyOrders/MyOrders";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Help from "./components/Help/Help";
import AppDownload from "./components/AppDownload/AppDownload";

const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#ffc115cb",
    },
  },
});

const App = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();

  useEffect(() => {
    axios.interceptors.request.use((config) => {
      dispatch({ type: sagaActions.API_CALL_START });
      return config;
    });
    axios.interceptors.response.use((config) => {
      dispatch({ type: sagaActions.API_CALL_END });
      return config;
    });

    dispatch({ type: sagaActions.SPICES_LOAD_REQUEST });
    dispatch({ type: sagaActions.INCENSES_LOAD_REQUEST });
    dispatch({ type: sagaActions.HOME_LOOKUPS_LOAD_REQUEST });
    dispatch({ type: sagaActions.CONTACTS_LOAD_REQUEST });
    dispatch(loadCart());
    dispatch(loadAddress());
  }, [dispatch]);

  return (
    <div className="App">
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <ScrollToTop />
        <Header />
        <div className="app-container">
          <Routes>
            <Route path={ROUTE_PATH.BASE} element={<Home />} />
            <Route path={ROUTE_PATH.ABOUT} element={<About />} />
            <Route path={ROUTE_PATH.CONTACT} element={<Contact />} />
            <Route path={ROUTE_PATH.CART} element={<Cart />} />
            <Route path={ROUTE_PATH.CHECKOUT} element={<Checkout />} />
            <Route path={ROUTE_PATH.TERMS} element={<Terms />} />

            <Route path={ROUTE_PATH.INCENSES} element={<Incenses />} />
            <Route path={ROUTE_PATH.SPICES} element={<Spices />} />
            <Route path={ROUTE_PATH.B2B} element={<B2B />} />
            <Route
              path={ROUTE_PATH.PRODUCT_DETAILS + ":id/:type"}
              element={<ProductDetails />}
            />
            <Route path={ROUTE_PATH.MY_ORDER} element={<MyOrders />} />
            <Route
              path="*"
              element={
                <div>
                  <h1>{t("404_not_found")}</h1>
                </div>
              }
            />
          </Routes>
        </div>
        <Footer />
        <Help />
        <AppDownload />
      </ThemeProvider>
    </div>
  );
};

export default App;
